import { hot } from "react-hot-loader/root";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AppComponent from "./components";
import { updateViewport, setUserInfo } from "../../actions";
import {
  fetchNotificaton,
  resetNotificationUpdatedFlag
} from "../Notification/store/actions";
// import { withAdalLoginApi, authContext } from "../../config/adal";
import Fallback from "../Common/Fallback";
import ErrorPage from "../Common/ErrorPage";
import { any } from "prop-types";
const mapStateToProps = ({ app, notification }) => ({
  isLoading: app.isLoading,
  userInfo: app.userInfo,
  menuKey: app.menuKey,
  notificationUpdated: notification.notificationUpdated,
  msalContext: any
});

const mapDispatchToProps = {
  updateViewport,
  setUserInfo,
  fetchNotificaton,
  resetNotificationUpdatedFlag
};

const App = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(hot(AppComponent))
);

// TODO:: need to change this with new package
// export default withAdalLoginApi(App, Fallback, ErrorPage);
export default App;
